(() => {
  const NOTICE_TTL = 60 * 60 * 1000; // 1時間

  const initRoot = (root) => {
    if (root.dataset.ticketNoticeBound === 'true') return;
    root.dataset.ticketNoticeBound = 'true';

    const form = root.closest('form');
    if (!form) return;

    const overlay = root.querySelector('.js-ticket-notice-overlay');
    const check = root.querySelector('.js-ticket-notice-check');
    const accept = root.querySelector('.js-ticket-notice-accept');
    const error = root.querySelector('.js-ticket-notice-error');
    const property = root.querySelector('.js-ticket-notice-property');
    const storageKey = root.dataset.ticketKey;

    if (!overlay || !check || !accept || !error || !property || !storageKey) return;

    if (overlay.parentNode !== document.body) {
      document.body.appendChild(overlay);
    }

    const open = () => {
      overlay.hidden = false;
      document.body.classList.add('ticket-notice-lock');
    };

    const close = () => {
      overlay.hidden = true;
      document.body.classList.remove('ticket-notice-lock');
    };

    const sync = () => {
      accept.disabled = !check.checked;
      if (check.checked) {
        error.hidden = true;
      }
    };

    const resetState = () => {
      property.value = '';
      check.checked = false;
      sync();
    };

    const approve = () => {
      property.value = '確認済み';
      check.checked = true;
      sync();
    };

    const readSavedState = () => {
      try {
        const raw = window.localStorage.getItem(storageKey);
        if (!raw) return null;

        const parsed = JSON.parse(raw);
        if (
          !parsed ||
          parsed.confirmed !== true ||
          typeof parsed.confirmedAt !== 'number'
        ) {
          return null;
        }

        return parsed;
      } catch (e) {
        return null;
      }
    };

    const isStillValid = (saved) => {
      if (!saved) return false;
      return Date.now() - saved.confirmedAt < NOTICE_TTL;
    };

    const saveApprovedState = () => {
      try {
        window.localStorage.setItem(
          storageKey,
          JSON.stringify({
            confirmed: true,
            confirmedAt: Date.now()
          })
        );
      } catch (e) {}
    };

    const saved = readSavedState();
    const seen = isStillValid(saved);

    if (seen) {
      approve();
      close();
    } else {
      resetState();
      open();
    }

    check.addEventListener('change', sync);

    accept.addEventListener('click', () => {
      if (!check.checked) {
        error.hidden = false;
        return;
      }

      approve();
      saveApprovedState();
      close();
    });

    form.addEventListener(
      'submit',
      (event) => {
        const currentSaved = readSavedState();
        const currentSeen = isStillValid(currentSaved);

        if (property.value === '確認済み' && currentSeen) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        resetState();
        error.hidden = false;
        open();
      },
      true
    );
  };

  const boot = () => {
    document.querySelectorAll('.js-ticket-notice-root').forEach(initRoot);
  };

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('product-info:loaded', boot);
})();